export default function parse (tag, cb, bind) {
  let elems = $(tag)
  if (elems.length) {
    for (var i = 0, len = elems.length; i < len; i++) {
      cb.call(bind, elems[i])
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/parse.js